const DEFAULT_ERROR_MESSAGE = 'Undefined place ID in route';

export default class UndefinedPlaceIdInRoute extends Error {
  constructor(message: string = DEFAULT_ERROR_MESSAGE) {
    super(message);
  }
}
